import { render } from "./OAuth.vue?vue&type=template&id=cd4748e2&scoped=true"
import script from "./OAuth.vue?vue&type=script&lang=js"
export * from "./OAuth.vue?vue&type=script&lang=js"

import "@/assets/styles/login.css?vue&type=style&index=0&id=cd4748e2&scoped=true&lang=css&external"
import "./OAuth.vue?vue&type=style&index=1&id=cd4748e2&scoped=true&lang=css"
import "./OAuth.vue?vue&type=style&index=2&id=cd4748e2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd4748e2"]])

export default __exports__